import React from 'react';

// css
import styles from './SplitTextRow.css';

const SplitLineRowText = props => {
  const { rowL1Data, rowL2Data } = props;
  return (
    <React.Fragment>
      <p className={styles.rowL1}>
        {rowL1Data !== undefined &&
        rowL1Data !== null &&
        rowL1Data !== 'null null' &&
        rowL1Data !== ''
          ? rowL1Data
          : '-'}
      </p>
      <p className={styles.rowL2}>
        {rowL2Data !== undefined && rowL2Data !== null && rowL2Data !== ''
          ? rowL2Data
          : '-'}
      </p>
    </React.Fragment>
  );
};

export default SplitLineRowText;



// WEBPACK FOOTER //
// ./src/views/components/Common/Table/CellRendererComponents/SplitTextRow/SplitTextRow.jsx